module.exports = __webpack_public_path__ + "static/scale-model-of-mount-vernon-place-conservancy-in-baltimore-maryland-7b4bef84e7595b3b9228764354a96d3d.png";